import EmailIcon from '@material-ui/icons/Email';
import styled, { css } from 'styled-components';

export const Logo = styled.img`
  margin-bottom: 1rem;
`;

export const FormContainer = styled.form`
  width: 100%;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 820px;
  margin: 0 1rem;

  gap: 3rem;

  transform: translateY(calc(-35vh + 50%));

  @media only screen and (max-width: 600px) {
    gap: 1rem;
  }
`;

export const SocialLoginLink = styled.a`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    width: 100%;
    display: flex;
    align-items: center;
    font-family: 'Roboto', sans-serif;
    color: #242d3e;
    background-color: #fff;
    border: 1px solid #dfe1e5;
    cursor: pointer;
    border-radius: 4px;
    margin: 0.2rem 0;
    padding: 0.375rem 2rem;
    transition: all 0.2s ease-in-out;
    transform: translateZ(0);
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;

    .img {
      object-fit: contain;
      min-width: 60px;
    }

    &:hover {
      background-color: #f5f5f5;
      color: #1991eb;
      border: 1px solid #1991eb;
    }

    &[aria-disabled='true'] {
      cursor: not-allowed;
      background-color: ${theme.palette.action.disabled};
      border-color: ${theme.palette.action.disabled};
      color: #242d3e;

      & img {
        filter: grayscale(100%);
      }
    }
  `}
`;

export const ButtonTitle = styled.div`
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  p {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RedirectLoginContainer = styled.div`
  width: 100%;
  max-width: 500px;

  background-color: ${({ theme }) => theme.splitcPalette.background[1]};
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;

  & p {
    margin: 0;
  }
`;

export const RedirectMessage = styled.p`
  padding: 3rem;
  text-align: center;
`;

export const LoginContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  width: 100%;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

export const SeparatorContainer = styled.div`
  ${({ theme }) => css`
    width: 1px;
    min-height: 150px;
    background-color: ${theme.palette.divider};

    @media only screen and (max-width: 600px) {
      width: 100%;
      min-height: 1px;
    }
  `}
`;

export const SelectedEmailContainer = styled.div`
  ${({ theme }) => css`
    text-align: center;
    width: 100%;

    & > h4 {
      margin: 16px 0 30px 0;
      font-weight: 400;

      & > span {
        font-size: 20px;
        color: ${theme.palette.primary.light};
        font-weight: 500;
      }
    }

    & > button {
      width: 100%;
    }
  `}
`;

export const NotFoundProvider = styled.div`
  text-align: center;
`;

export const ErrorContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ErrorContentContainer = styled.div`
  width: 100%;
  max-width: 400px;

  background-color: ${({ theme }) => theme.splitcPalette.background[1]};
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;

  & p {
    margin: 0;
  }
`;

export const ProvidersContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;

  @media only screen and (max-width: 600px) {
    max-width: 100%;
  }
`;

export const AuthenticationMethodMessage = styled.p`
  margin: 0;
  position: absolute;
  transform: translateY(-125%);
  font-size: 16px;
  text-align: center;
  width: 100%;
`;

export const AttempErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 2rem;
  padding-right: 2rem;
  width: 100%;
  height: 100%;
`;

export const ContentList = styled.ul`
  margin-left: 1rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const InvalidAttemptMsg = styled.h2`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.3rem;
  text-align: center;
`;

export const InvalidAttemptSubMsg = styled.h4`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const ClerkModalContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.background.default};
  width: 25vw;
  height: 25vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  outline: none;
  text-align: center;
  border-radius: 8px;
`;

export const ClerkModalIcon = styled(EmailIcon)`
  fontsize: 60;
  marginbottom: 10;
`;
